/*eslint-disable */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLobbyMode } from '../../lobby/actions.any';
import { COMMANDS } from '../../mod-command/constants';
import { sendCommand } from '../../mod-command/slice';
import { getRemoteParticipantCount, showWarningLimitedParticipantsRoom } from '../../base/participants';
import { getLimitUsers } from '../../user/functions';
import { activeLockRoom, unActiveLockRoom } from '../../base/test/slice';
const useMeetingAccess = () => {
    const security = useSelector((state) => state['features/lock-room']);
    const lobby = useSelector((state) => state['features/lobby']);
    const dispatch = useDispatch();
    // const functions = useSelector((state: IReduxState) => getFunctions(state));
    const limitUsers = useSelector((state) => getLimitUsers(state));
    const remoteParticipantsCount = useSelector((state) => getRemoteParticipantCount(state));
    const handleChange = (key, value) => {
        let _items = [...items];
        switch (key) {
            case "lockroom":
                if (value)
                    dispatch(activeLockRoom());
                else
                    dispatch(unActiveLockRoom());
                // lockRoom(value, APP.store.getState());
                dispatch(sendCommand(COMMANDS.LOCK.COMMAND, value ? COMMANDS.LOCK.ON : COMMANDS.LOCK.OFF, true));
                _items[0].checked = value;
                setItems(_items);
                break;
            case "activeLobby":
                const isLimit = limitUsers <= remoteParticipantsCount + 1;
                if (isLimit) {
                    showWarningLimitedParticipantsRoom({ dispatch, typeWarning: 'disableLobby' });
                    break;
                }
                dispatch(toggleLobbyMode(value));
                _items[1].checked = value;
                setItems(_items);
                break;
            default:
                break;
        }
    };
    const [items, setItems] = useState(() => {
        return [
            {
                key: 'lockroom',
                name: 'security.lockClass',
                checked: security?.isLocked,
                onChange: handleChange
            },
            {
                key: 'activeLobby',
                name: 'security.activeRoom',
                checked: lobby?.lobbyEnabled,
                onChange: handleChange
            }
        ];
    });
    useEffect(() => {
        let _items = [...items];
        _items[0].checked = security?.isLocked;
        setItems(_items);
    }, [security?.isLocked]);
    useEffect(() => {
        let _items = [...items];
        _items[1].checked = lobby?.lobbyEnabled;
        setItems(_items);
    }, [lobby?.lobbyEnabled]);
    return {
        items
    };
};
export default useMeetingAccess;
